import React, { useContext, useEffect, useState } from "react";
import "./CurrentDashboardCard.css";
import { ThemeContext } from "../../../..";

export default function CurrentDashboardCard({
  data,
  config,
  clickedKey,
  setClickedKey,
  triggeredFunction,
}) {
  const colors = ["#519EFE", "#b981f6", "#E28771", "#D252AA"];
  const [cardData, setCardData] = useState({});
  const { theme } = useContext(ThemeContext);
  useEffect(() => {
    setCardData(data);
  }, [data]);
  return (
    <div className="current-dashboard_card">
      <div className="curr-card">
        {config?.data.map((conf, index) => (
          <div
            key={index}
            className={`cds-single_card cursor-pointer ${
              clickedKey === conf.key ? "highlighted" : ""
            }`}
            onClick={() => {
              setClickedKey(conf?.key);
              triggeredFunction(
                conf?.label,
                conf?.apiKey,
                conf?.key,
                conf?.apiKey2
              );
            }}
            style={{backgroundColor: theme === "light" ? "#F0F0F0" : colors[index % colors.length], color: theme === "light" ? "black" : "white"  }}>
            <div className="card-label">{conf.label}</div>
            <div style={{fontWeight: "bold"}}>
              {cardData && cardData[conf?.key] ? cardData[conf?.key] : 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
